import {useEffect} from 'react';

const useInit = (initFunc: Function) => {
  useEffect(() => initFunc(), [])
};

export default useInit;
